(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merch-quote-form"] && !Shopify.designMode) return;
  try {
    
  customElements.define(
    'merch-kit-builder',
    class extends HTMLElement {
      connectedCallback() {
        this.boxes = [...this.querySelectorAll('.merch-build__tile input[type="checkbox"]')];
        if (!this.boxes.length) return;
        this.money = new Intl.NumberFormat('en-NG', { style: 'currency', currency: this.dataset.currency || 'NGN', maximumFractionDigits: 0 });
        this.kits = this.querySelector('[data-kits]');
        this.boxes.forEach((box) => box.addEventListener('change', () => this.render()));
        this.kits.addEventListener('input', () => this.render());
        this.querySelector('form').addEventListener('submit', (event) => {
          if (this.selected().length === 0) {
            event.preventDefault();
            this.showError('Pick at least one item for your kit.');
            this.boxes[0].focus();
          }
        });
        this.render();
      }

      selected() {
        return this.boxes.filter((box) => box.checked);
      }

      showError(message) {
        const error = this.querySelector('[data-error]');
        error.textContent = message;
        error.hidden = !message;
      }

      render() {
        const picked = this.selected();
        const list = this.querySelector('[data-list]');
        list.replaceChildren(
          ...picked.map((box) => {
            const li = document.createElement('li');
            const thumb = document.createElement('img');
            thumb.className = 'merch-build__thumb';
            thumb.alt = '';
            thumb.width = 40;
            thumb.height = 40;
            if (box.dataset.image) thumb.src = box.dataset.image;
            const name = document.createElement('span');
            name.className = 'merch-build__item-name';
            name.textContent = box.dataset.title;
            const remove = document.createElement('button');
            remove.type = 'button';
            remove.className = 'merch-build__remove';
            remove.innerHTML = '<svg aria-hidden="true" viewBox="0 0 16 16" width="14" height="14"><path d="M4 4l8 8M12 4l-8 8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
            remove.setAttribute('aria-label', `Remove ${box.dataset.title}`);
            remove.addEventListener('click', () => {
              box.checked = false;
              this.render();
            });
            li.append(thumb, name, remove);
            return li;
          })
        );
        this.querySelector('[data-empty]').hidden = picked.length > 0;
        if (picked.length) this.showError('');

        const perKit = picked.reduce((sum, box) => sum + Number(box.dataset.price || 0), 0) / 100;
        const count = Math.max(0, Number.parseInt(this.kits.value, 10) || 0);
        const estimate = this.querySelector('[data-estimate]');
        estimate.hidden = picked.length === 0;
        this.querySelector('[data-per-kit]').textContent = `From ${this.money.format(perKit)}`;
        this.querySelector('[data-total]').textContent = count ? `About ${this.money.format(perKit * count)} for ${count} kits` : '';
        this.querySelector('[data-estimate-field]').value = picked.length
          ? `From ${this.money.format(perKit)} per kit x ${count} = ${this.money.format(perKit * count)}`
          : '';

        const bar = this.querySelector('[data-bar]');
        bar.hidden = picked.length === 0;
        this.querySelector('[data-bar-count]').textContent = `${picked.length} item${picked.length === 1 ? '' : 's'}`;
        this.querySelector('[data-bar-price]').textContent = `from ${this.money.format(perKit)} per kit`;
      }
    }
  );

  } catch(e) { console.error(e); }
})();
})();
